if (!customElements.get('multi-image-comparison')) {
  customElements.define('multi-image-comparison', class MultiImageComparison extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';

      this.panels = Array.from(this.querySelectorAll('[data-comparison-panel]'));
      this.index = Math.max(this.panels.findIndex((panel) => !panel.hidden), 0);

      this.addEventListener('click', (event) => {
        const previous = event.target.closest('[data-comparison-prev]');
        const next = event.target.closest('[data-comparison-next]');

        if (!previous && !next) return;

        event.preventDefault();
        const direction = next ? 'next' : 'prev';
        this.show(this.index + (next ? 1 : -1), direction, event.detail === 0);
      });
    }

    show(index, direction, shouldFocus) {
      const count = this.panels.length;
      if (count < 2) return;

      this.index = (index + count) % count;
      this.panels.forEach((panel, panelIndex) => {
        panel.hidden = panelIndex !== this.index;
      });

      if (!shouldFocus) return;

      const selector = direction === 'next' ? '[data-comparison-next]' : '[data-comparison-prev]';
      this.panels[this.index].querySelector(selector)?.focus({ preventScroll: true });
    }
  });
}
